import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormbuilderValidationService } from './../../../services/formbuilder-validation.service';
import { NotificationsService } from 'src/app/shared/NotificationsService/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationMessage ,NotificationType } from 'src/app/entity/NotificationMessage';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-string-type',
  templateUrl: './string-type.component.html',
  styleUrls: ['./string-type.component.scss'],
})
export class StringTypeComponent extends FieldType implements OnInit {
  stringFormControl = new FormControl('', []);
  matcher = new MyErrorStateMatcher();
  fieldName: any;
  searchValue: any;
  loader: boolean;
  alerts: any;
  buttons: any;
  tickets_id: string;
  urlIdentifiant: any;

  constructor(private validationService: FormbuilderValidationService,
    private notificationsService: NotificationsService,
    private translate : TranslateService,
    private routes: Router,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('languages').subscribe((object: any) => {
        this.alerts = object.alerts;
        this.buttons = object.buttons;
      });});

      this.translate.get('languages').subscribe((object: any) => {
        this.alerts = object.alerts;
        this.buttons = object.buttons;
      });
    this.fieldName = this.field.key || `stringField_${Math.random().toString(36).substr(2, 9)}`;
    const pattern = this.field.templateOptions?.pattern || '';
    this.urlIdentifiant =this.field.templateOptions?.urlIdentifiant 
    // Set validators based on the pattern from templateOptions
    this.stringFormControl.setValidators([ this.patternValidator(pattern)]);
    this.searchValue=this.field.templateOptions?.autofill
    if (this.field.templateOptions?.autofill) {
      this.stringFormControl.disable();
    } else {
      this.stringFormControl.enable();
    }
    if (this.formControl.value) {
      this.stringFormControl.setValue(this.formControl.value);
    }

    // Sync form control value with Formly
    this.stringFormControl.valueChanges.subscribe((value) => {
      this.formControl.setValue(value);
      this.emitValidationStatus();
    });
    this.emitValidationStatus();
  }

  private emitValidationStatus(): void {

    const isValid = this.stringFormControl.disabled || this.stringFormControl.valid;
    this.validationService.updateValidationStatus(this.fieldName, isValid, this.field.templateOptions?.label);
  }

  private patternValidator(pattern: string | RegExp): (control: FormControl) => { [key: string]: any } | null {
    return (control: FormControl): { [key: string]: any } | null => {
      const regex = new RegExp(pattern);
      if (control.value && !regex.test(control.value)) {
        return { pattern: true };
      }
      return null;
    };
  }
  

 
  updateValue(event: Event): void {
    const currentRoute = this.routes.url;
    if (currentRoute.includes('ticketsandsupport')) {
      this.route.paramMap.subscribe((params) => {
        this.tickets_id = params.get('tickets_id');
        this.loader=true
        this.validationService.getAllInfoTicket(this.tickets_id).subscribe(
          (response) => {
            this.loader=false
            if (this.urlIdentifiant) {
              this.loader=true
              const bodyTicket=response
              this.validationService.consumeAutoFillInputs(this.urlIdentifiant , bodyTicket).subscribe(
                (response) => {
                  this.loader=false
                    this.stringFormControl.setValue(response.response.value);
                    const notificationMessage = new NotificationMessage();
                    notificationMessage.type = NotificationType.success;
                    notificationMessage.title = this.alerts.Successoperation;
                    notificationMessage.message = response?.message;
                    this.notificationsService.sendMessage(notificationMessage);
                },
                (error) => {
                  this.loader=false
                const notificationMessage = new NotificationMessage();
                notificationMessage.type = NotificationType.error;
                notificationMessage.title = this.alerts.Operationechoue;
                if (error.status != "500"){
                  notificationMessage.message = error?.error?.message;
                }
                this.notificationsService.sendMessage(notificationMessage);
                }
              );
            } else {
              this.loader=false
              const notificationMessage = new NotificationMessage();
              notificationMessage.type = NotificationType.error;
              notificationMessage.title = this.alerts.Operationechoue;
              notificationMessage.message = this.alerts.urlServiceOblig;
              this.notificationsService.sendMessage(notificationMessage);
            }
             
          },
          (error) => {
          this.loader=false
          const notificationMessage = new NotificationMessage();
          notificationMessage.type = NotificationType.error;
          notificationMessage.title = this.alerts.Operationechoue;
          notificationMessage.message = error?.message?.message;
          this.notificationsService.sendMessage(notificationMessage);
          }
        );

      });
    }


    
    }

}
